import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../../constants/assets/containers";
import NoFooterModal from "../../../Common/NoFooterModal";
import PaginatedReactDropdown from "../../../Common/PaginatedReactDropdown";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Input from "sushiweb/InputTypes/Input";
import { FlexContainer } from "../../../../constants/assets/containers";
import styled from "styled-components";
import {
  isValNull,
  isValidCustomDeeplink,
  isValidURL,
} from "../../../../utils";

const AddCTAModal = (props) => {
  const {
    setModalState,
    inputFieldState,
    setInputFieldState,
    languageIndex,
    getInputLabel,
    newCampaignOptions,
    key,
    notification_for,
  } = props;

  const [formError, setFormError] = useState("");
  const [ctaDetails, setCtaDetails] = useState({
    name: "",
    deeplink: "",
    deep_redirection: "",
    external_url: "",
    value: "",
    custom_deeplink: "",
  });

  const handleClose = () => {
    setModalState(false);
  };

  const validateCTADetails = () => {
    let err = "";

    if (isValNull(ctaDetails.name) || ctaDetails.name.length > 25) {
      return "Name field within character limit is mandatory";
    }
    if (isValNull(ctaDetails.value)) {
      return "Action field is mandatory";
    }
    if (
      ctaDetails.deeplink == "external" &&
      (isValNull(ctaDetails.external_url) ||
        !isValidURL(ctaDetails.external_url))
    ) {
      return "Not a valid external URL";
    }

    if (
      ctaDetails.deeplink == "custom_deeplink" &&
      !isValidCustomDeeplink(ctaDetails.custom_deeplink)
    ) {
      return "Don't use driver_app://";
    }

    if (newCampaignOptions.deep_redirections) {
      Object.keys(newCampaignOptions.deep_redirections).map(
        (redirection_key) => {
          if (
            redirection_key === ctaDetails.deeplink &&
            isValNull(ctaDetails.deep_redirection)
          ) {
            err = `${getInputLabel(
              redirection_key,
              newCampaignOptions.redirections,
              "value",
              "label"
            )} field is mandatory`;
          }
        }
      );
    }
    return err ? err : "validated";
  };

  const handleSubmit = () => {
    let validatedState = validateCTADetails();
    if (validatedState === "validated") {
      const values = { ...inputFieldState };
      const updatedCTADetails = { ...ctaDetails };
      if (updatedCTADetails.custom_deeplink) {
        updatedCTADetails.deeplink = updatedCTADetails.custom_deeplink;
      }
      delete updatedCTADetails["custom_deeplink"];
      const updatedNotifDetails = {
        ...values.notification_details[languageIndex],
        actions: [
          ...values.notification_details[languageIndex].actions,
          updatedCTADetails,
        ],
      };
      values.notification_details[languageIndex] = updatedNotifDetails;
      setInputFieldState(values);
      setModalState(false);
    } else {
      setFormError(validatedState);
    }
  };

  const handleChange = (key, val) => {
    if (key === "deeplink") {
      setCtaDetails((prevState) => {
        return {
          ...prevState,
          deep_redirection: "",
          external_url: "",
          custom_deeplink: "",
        };
      });
    }

    setCtaDetails((prevState) => {
      return { ...prevState, [key]: val };
    });
  };

  const getDeepRedirectionNameField = () => {
    if (ctaDetails.deeplink == "external") {
      return <p className="regular ml-10 mt-10 mb-60">External URL</p>;
    }
    if (ctaDetails.deeplink == "custom_deeplink") {
      return <p className="regular ml-10 mt-10 mb-60">Custom Deeplink</p>;
    }
    if (newCampaignOptions.deep_redirections) {
      return Object.keys(newCampaignOptions.deep_redirections).map(
        (redirection_key) => {
          if (redirection_key === ctaDetails.deeplink) {
            return (
              <p className="regular ml-10 mb-50">
                Select{" "}
                {getInputLabel(
                  redirection_key,
                  newCampaignOptions.redirections[notification_for],
                  "value",
                  "label"
                )}
              </p>
            );
          }
        }
      );
    }
  };

  const getDeepRedirectionInputField = () => {
    if (ctaDetails.deeplink == "external") {
      return (
        <Input
          value={ctaDetails.external_url}
          data-testid={`ctaURL${key}`}
          onChange={(e) => handleChange("external_url", e)}
          id="sushi-input"
        />
      );
    }
    if (ctaDetails.deeplink == "custom_deeplink") {
      return (
        <Input
          value={ctaDetails.custom_deeplink}
          data-testid={`ctaURL${key}`}
          onChange={(e) => handleChange("custom_deeplink", e)}
          id="sushi-input"
        />
      );
    }
    if (newCampaignOptions.deep_redirections) {
      return Object.entries(newCampaignOptions.deep_redirections).map(
        ([redirection_key, options]) => {
          if (redirection_key === ctaDetails.deeplink) {
            return (
              <Autocomplete
                value={getInputLabel(
                  ctaDetails.deep_redirection,
                  options,
                  "value",
                  "label"
                )}
                onChange={(event, newValue) => {
                  const item = options.find((item) => item.label === newValue);
                  var value = item ? item.value : null;
                  handleChange("deep_redirection", value);
                }}
                closeIcon={false}
                data-testid={`deepRedirection${redirection_key}`}
                id={`deepRedirection${redirection_key}`}
                options={options.map((item) => item.label)}
                style={{ width: 300 }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
            );
          }
        }
      );
    }
  };

  const getConfirmButton = () => {
    return (
      <BottomSectionModal className="flex justify-center ">
        <Button
          data-testid="submitCTADetailsModal"
          className="sushi-btn"
          onClick={handleSubmit}
        >
          Confirm
        </Button>
      </BottomSectionModal>
    );
  };

  return (
    <NoFooterModal
      header={true}
      heading="Call to Action Builder"
      handleClose={handleClose}
      id="ctaDetailsModal"
      modalButtons={getConfirmButton()}
    >
      <FlexContainer>
        <NamesDiv>
          <p className="regular ml-10 mb-50">Name</p>
          {newCampaignOptions.redirections[notification_for] && (
            <p className="regular ml-10 mt-10 mb-60">Redirect to</p>
          )}
          {getDeepRedirectionNameField()}
          {newCampaignOptions.cta && (
            <p className="regular ml-10 mt-10 mb-40">Action</p>
          )}
        </NamesDiv>
        <InputElements>
          <Input
            value={ctaDetails.name}
            data-testid={`ctaName${key}`}
            onChange={(e) => handleChange("name", e)}
            id="sushi-input"
            helperText="&emsp;&emsp;Character Limit: 25"
            errorMsg={
              ctaDetails.name.length > 25
                ? `Character Limit Exceeded by ${
                    ctaDetails.name.length - 25
                  } characters`
                : ""
            }
          />
          {newCampaignOptions.redirections[notification_for] && (
            <Autocomplete
              value={getInputLabel(
                ctaDetails.deeplink,
                newCampaignOptions.redirections[notification_for],
                "value",
                "label"
              )}
              onChange={(event, newValue) => {
                const item = newCampaignOptions.redirections[notification_for].find(
                  (item) => item.label === newValue
                );
                var value = item ? item.value : null;
                handleChange("deeplink", value);
              }}
              closeIcon={false}
              data-testid="ctaRedirections"
              id="ctaRedirections"
              options={newCampaignOptions.redirections[notification_for].map(
                (item) => item.label
              )}
              style={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          )}
          {getDeepRedirectionInputField()}
          {newCampaignOptions.cta && (
            <PaginatedReactDropdown
              placeholder=""
              options={newCampaignOptions.cta}
              labelKey="label"
              valueKey="value"
              data-testid="ctaActionType"
              value={getInputLabel(
                ctaDetails.value,
                newCampaignOptions.cta,
                "value",
                "label"
              )}
              handleChange={handleChange}
              keyToChange="value"
              id="ctaActionType"
            />
          )}
        </InputElements>
      </FlexContainer>
      {formError.length > 0 ? (
        <div className={"error-state"}>{"*" + formError}</div>
      ) : (
        ""
      )}
    </NoFooterModal>
  );
};

const NamesDiv = styled.div`
  justify-content: flex-start;
  flex: 0 1 38%;
  p {
    font-family: "OkraRegular", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif !important;
  }
  margin-top: 15px;
`;

const InputElements = styled.div`
  flex: 0 1 62%;
`;

export default AddCTAModal;
